import axios from 'axios';
import { setAlert } from './alert';

import {
    GET_PROFILE,
    PROFILE_ERROR,
    CLEAR_PROFILE, GET_UPDLIST, CLEAR_UPDLIST,
    EDIT_PROFILE, SET_DBCALL, RESET_DBCALL
} from './types';

//Create or Update Profile

import moment from 'moment';

export const movetoIneligible = (formData, history) => async dispatch => {
  try {

      dispatch({
          type: SET_DBCALL
        });

      //dispatch(setAlert("Processing...", 'danger'));

      console.log("Moving to ineligible list " + formData.appId);

      const config = {
          headers: {
              'Content-type': 'application/json'
          }
      }
      const res = await axios.post('api/master/ineligible', formData, config);

      dispatch({
          type: RESET_DBCALL
        });

      dispatch({
          type: CLEAR_PROFILE,
          payload: res.data
      });

      dispatch(setAlert(res.data.msg, 'primary'));


  } catch (err) {

      console.log("Catch");

      dispatch({
          type: RESET_DBCALL
        });

      const errors = err.response.data.errors;

      if(errors) {
          errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
      }

      dispatch({
          type: PROFILE_ERROR,
          payload: { msg: err.response.statusText, status: err.response.status }
      });

  }
};


export const updateCV = (formData, history) => async dispatch => {
    try {

        dispatch({
            type: SET_DBCALL
          });

        //dispatch(setAlert("Processing...", 'danger'));

        const config = {
            headers: {
                'Content-type': 'application/json'
            }
        }
        //console.log(formData);
        //console.log("Received from Client" + formData.vflag);
        const res = await axios.post('api/master/update', formData, config);
        //console.log("dispatched updatecv for " + formData._aid);
        //console.log(formData);

        dispatch({
            type: RESET_DBCALL
          });

        

        dispatch({
            type: CLEAR_PROFILE,
            payload: res.data
        });

        dispatch(setAlert(res.data.msg, 'primary'));

        //dispatch({
        //    type: GET_PROFILE,
        //    payload: res.data
        //});

        //dispatch( setAlert(formData.vflag === 'vcomplete' ? 'Completed Successfully' : 
          //      (formData.vflag === 'toupdate' ? 'Sent for Updation' : 
            //    (formData.vflag === 'present' ? 'Marked Present' : null)), 'primary'));
        
        //clearApplication();

        //console.log("Got after db");
        //console.log(res.data);
        //if(!edit) {        
        //}

    } catch (err) {

        console.log("Catch");

        dispatch({
            type: RESET_DBCALL
          });

        const errors = err.response.data.errors;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};


export const getProfileCor = appId => async dispatch => {
    try {

        dispatch({
            type: SET_DBCALL
          });
    
          dispatch({
            type: CLEAR_PROFILE,
            payload: null
        });


      console.log("Invoking get profile by ID");
      const res = await axios.get(`/api/master/cor/${appId}`);

     // console.log(res);
  
      dispatch({
        type: GET_PROFILE,
        payload: res.data
      });      
      
      //console.log(res.data);
      //console.log("Invoking get profile by ID");
      //const res2 = await axios.get(`/api/master/cor/log/${appId}`);
  
      //dispatch({
      //  type: LOG_PROFILE,
      //  payload: res2.data
      //});      

      dispatch({
        type: RESET_DBCALL
      });
  
      
    } 
    
    catch (err) {

        console.log("Catch");
        dispatch({
            type: RESET_DBCALL
          });
        
        dispatch(setAlert("Invalid Application", 'danger'));
        
        /*console.log(err.response.data);
        const errors = err.response.data;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(errors, 'danger')));
        }*/

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};




export const changeAppStatus = (formData, history) => async dispatch => {
    
    try {

        dispatch({
            type: SET_DBCALL
          });

        const config = {
            headers: {
                'Content-type': 'application/json'
            }
        }
        
        const res = await axios.post('api/master/changestatus', formData, config);
        console.log("dispatched change status");
        
        dispatch(setAlert(res.data.msg, 'primary'));

        dispatch({
            type: CLEAR_PROFILE,
            payload: res.data
        });

        history.push('/dashboard');

        dispatch({
            type: RESET_DBCALL
          });

    } catch (err) {

        console.log("Catch Status db error");
        dispatch({
            type: RESET_DBCALL
          });
        
        const errors = err.response.data.errors;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};

export const getUpdpendingforme = uname => async dispatch => {
  try {

      dispatch({
          type: SET_DBCALL
        });

        dispatch({
          type: CLEAR_UPDLIST,
      });

  console.log("Invoking get profile Upd");
  const res = await axios.get(`/api/master/updme/${uname}`);

    dispatch({
      type: GET_UPDLIST,
      payload: res.data
    });      
    
    console.log("after db retrieve");
    //console.log(res.data);

    dispatch({
      type: RESET_DBCALL
    });

  } 
  
  catch (err) {

      console.log("Catch");

      dispatch({
          type: RESET_DBCALL
        });
          
      dispatch(setAlert(err.response.data.msg, 'danger'));
      
      /*console.log(err.response.data);
      const errors = err.response.data;

      if(errors) {
          errors.forEach(error => dispatch(setAlert(errors, 'danger')));
      }*/

      dispatch({
          type: PROFILE_ERROR,
          payload: { msg: err.response.statusText, status: err.response.status }
      });

  }
};


export const getProfileUpd = appId => async dispatch => {
    try {

        dispatch({
            type: SET_DBCALL
          });

          dispatch({
            type: CLEAR_PROFILE,
            payload: null
        });

    console.log("Invoking get profile Upd");
    const res = await axios.get(`/api/master/upd/${appId}`);

    console.log("response");
    console.log(res.data);
  
      dispatch({
        type: GET_PROFILE,
        payload: res.data
      });      
      
      console.log("after db retrieve");
      //console.log(res.data);

      dispatch({
        type: RESET_DBCALL
      });

    } 
    
    catch (err) {

        console.log("Catch");
        console.log(err);

        dispatch({
            type: RESET_DBCALL
          });
            
        dispatch(setAlert(err.response.data.msg, 'danger'));
        
        /*console.log(err.response.data);
        const errors = err.response.data;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(errors, 'danger')));
        }*/

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};

export const getProfilePdf = appId => async dispatch => {
    try {

        dispatch({
            type: SET_DBCALL
          });

      console.log("Invoking get profile PDF");
      const res = await axios.get(`/api/master/pdf/${appId}`);
  
      dispatch({
        type: GET_PROFILE,
        payload: res.data
      });          
      
      console.log("after db retrieve");
      //console.log(res.data);

      dispatch({
        type: RESET_DBCALL
      });



    } 
    
    catch (err) {

        console.log("Catch");

        dispatch({
            type: RESET_DBCALL
          });

        
        dispatch(setAlert(err.response.data.msg, 'danger'));
        
        /*console.log(err.response.data);
        const errors = err.response.data;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(errors, 'danger')));
        }*/

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};

export const getenableupload = appId => async dispatch => {
  try {

      dispatch({
          type: SET_DBCALL
        });

    console.log("Invoking get enable upload");
    const res = await axios.get(`/api/master/unfreeze/${appId}`);    
    
    console.log("after db retrieve");
    console.log(res.data);

    dispatch({
      type: RESET_DBCALL
    });



  } 
  
  catch (err) {

      console.log("Catch");

      dispatch({
          type: RESET_DBCALL
        });

      
      dispatch(setAlert(err.response.data.msg, 'danger'));
      
      /*console.log(err.response.data);
      const errors = err.response.data;

      if(errors) {
          errors.forEach(error => dispatch(setAlert(errors, 'danger')));
      }*/

      dispatch({
          type: PROFILE_ERROR,
          payload: { msg: err.response.statusText, status: err.response.status }
      });

  }
};


export const getProfileVer = appId => async dispatch => {
    try {

        dispatch({
            type: SET_DBCALL
          });
    
          dispatch({
            type: CLEAR_PROFILE,
            payload: null
        });


      console.log("Invoking get profile by ID");
      const res = await axios.get(`/api/master/ver/${appId}`);
  
      dispatch({
        type: GET_PROFILE,
        payload: res.data
      });      
      
      //console.log(res.data);

      dispatch({
        type: RESET_DBCALL
      });

    } 
    
    catch (err) {

        console.log("Catch");
        
        dispatch(setAlert(err.response.data.msg, 'danger'));
        
        /*console.log(err.response.data);
        const errors = err.response.data;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(errors, 'danger')));
        }*/

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};



// Get profile by ID
export const getProfileById = (appId) => async dispatch => {
    try {

        dispatch({
            type: SET_DBCALL
          });

          //dispatch(setAlert("Processsing ", 'danger'));

    console.log("Invoking get profile by ID " + appId);
      const res = await axios.get(`/api/master/user/${appId}`);
  
      dispatch({
        type: GET_PROFILE,
        payload: res.data
      });      

      dispatch({
        type: RESET_DBCALL
      });
  
      
      //console.log(res.data);
      console.log("output for get profile by id");
    } 
    
    catch (err) {

        console.log(err);
        dispatch({
          type: RESET_DBCALL
        });

        console.log("Catch");
        
        dispatch(setAlert(err.response.data.msg, 'danger'));
        
        /*console.log(err.response.data);
        const errors = err.response.data;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(errors, 'danger')));
        }*/

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};

export const getProfileAdmin = (appId) => async dispatch => {
    try {
    
    console.log("Invoking get profile for Admin " + appId);
      const res = await axios.get(`/api/master/admin/${appId}`);
  
      dispatch({
        type: GET_PROFILE,
        payload: res.data
      });      
      
      //console.log(res.data);
      console.log("output for get profile by id");
    } 
    
    catch (err) {

        console.log("Catch");
        
        dispatch(setAlert(err.response.data.msg, 'danger'));
        
        /*console.log(err.response.data);
        const errors = err.response.data;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(errors, 'danger')));
        }*/

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};

  export const clearApplication = (history) => async dispatch => {
    //console.log("clearing the profile");
    dispatch({
        type: SET_DBCALL
      });

    dispatch({
        type: CLEAR_PROFILE,
        payload: null
    });

    history.push('/dashboard');

    dispatch({
        type: RESET_DBCALL
      });
  };

  export const clearApplication2 = (history) => async dispatch => {
    //console.log("clearing the profile");
    dispatch({
        type: CLEAR_PROFILE,
        payload: null
    });

    //history.push('/dload');
  };

  export const createCV = (formData, history) => async dispatch => {
    try {


        dispatch({
            type: SET_DBCALL
          });

        const config = {
            headers: {
                'Content-type': 'application/json'
            }
        }

        //console.log(formData);

        if(formData._cv !== undefined ) {

          //console.log("got you");
  
          var d1 = moment(formData._cv.d, 'DD-MM-YYYY');
          var r1 = new Date(d1);
  
          //var td = moment().format('DD-MM-YYYY');
          //console.log("td " + td);
          var r2 = new Date();
  
          //console.log(r1);
          //console.log(r2);

          //console.log("diff " + (r1-r2));

          /*const diffTime = Math.abs(r1 - r2);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
          console.log(diffTime + " milliseconds");
          console.log(diffDays + " days"); */

          const _MS_PER_DAY = 1000 * 60 * 60 * 24;

            // a and b are javascript Date objects
            function dateDiffInDays(a, b) {
              // Discard the time and time-zone information.
              const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
              const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

              return Math.floor((utc2 - utc1) / _MS_PER_DAY);
            }

          //console.log(dateDiffInDays(r2,r1));

          if(parseInt(dateDiffInDays(r2,r1),10) <= 0) {
              console.log("Allowed CV");

              //dispatch(setAlert("Processing...", 'danger'));
              const res = await axios.post('api/master/create', formData, config);
              console.log("dispatched addcv for " + formData._aid);        
              
      
              dispatch(setAlert(res.data.msg, 'primary'));
                      
    
          }
          else
          {
              console.log("CV Not allowed");
              dispatch(setAlert("Kindly Check Schedule", 'danger'));
          }
      }

      dispatch({
        type: RESET_DBCALL
      });       



      dispatch({
        type: CLEAR_PROFILE,
      });
        //console.log(formData);
        //console.log("Received from Client" + formData.vflag);

      
    } catch (err) {        

        console.log("Catch");

        dispatch({
            type: RESET_DBCALL
          });

        const errors = err.response.data.errors;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};

export const adminchange = (formData, history) => async dispatch => {
    try {

        const config = {
            headers: {
                'Content-type': 'application/json'
            }
        }
        //console.log(formData);
        //console.log("Received from Client" + formData.vflag);
        const res = await axios.post('api/master/achange', formData, config);
        //console.log("dispatched admin changes for " + formData._aid);
        
        dispatch(setAlert(res.data.msg, 'primary'));

        //dispatch( setAlert(formData.vflag === 'vcomplete' ? 'Completed Successfully' : 
          //      (formData.vflag === 'toupdate' ? 'Sent for Updation' : 
           //     (formData.vflag === 'present' ? 'Marked Present' : null)), 'primary'));
        
        dispatch({
             type: CLEAR_PROFILE,
             payload: res.data
        });
                
        //console.log("Got after db");
        //console.log(res.data);
        //if(!edit) {
        history.push('/dashboard');
        //}

    } catch (err) {

        console.log("Catch");

        const errors = err.response.data.errors;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};


export const createChangeCV = (formData, history, edit = false) => async dispatch => {
    try {


          const config = {
            headers: {
                'Content-type': 'application/json'
            }
        }

        dispatch({
            type: CLEAR_PROFILE,
            payload: null
       });

       dispatch({
        type: SET_DBCALL
      });

        //console.log("Received from Client" + formData.vflag);
        const res = await axios.post('api/master/edit', formData, config);
        //console.log("dispatched addcv");
       

        dispatch( setAlert(formData.vflag === 'complete' ? 'Completed Successfully' : 
                (formData.vflag === 'toupdate' ? 'Send to Update' : 
                (formData.vflag === 'present' ? 'Marked Present' : (edit === true) ? 'Changes Saved' : "ERROR")), 'primary'));


        console.log("Got after db");
        //console.log(res.data);

        dispatch({
            type: EDIT_PROFILE,
            payload: res.data
        });


        history.push('/dashboard');

        dispatch({
            type: RESET_DBCALL
          });

    } catch (err) {

        console.log("Catch " + err.response.data.msg);
        dispatch({
            type: RESET_DBCALL
          });

        const errors = err.response.data.errors;                

        dispatch(setAlert(err.response.data.msg, 'danger', 8000));
        

        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};

export const saveIncompleteList = (formData) => async dispatch => {
    try {

        dispatch({
            type: SET_DBCALL
          });

        const config = {
            headers: {
                'Content-type': 'application/json'
            }
        }        
        console.log("received");
        console.log(formData);
        
        const res = await axios.post('api/master/incomp', formData, config);
        console.log("dispatched incomp with data below");
        //console.log(formData);


        dispatch(setAlert("Incomplete List Saved Successfully", 'primary'));
        
        dispatch({
            type: CLEAR_PROFILE,
                    payload: res.data
                });
                
        console.log("Got after db");
        //console.log(res.data);

        dispatch({
            type: RESET_DBCALL
          });


    } catch (err) {

        console.log("Catch");
        dispatch({
            type: RESET_DBCALL
          });

        const errors = err.response.data.errors;

        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: PROFILE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });

    }
};